/**
 * Set a cookie.
 * @param {String} name = name of cookie to set
 * @param {String} value = value of the cookie
 * @param {Date} maxAge = expire in specific number of seconds
 * @param {Number} days = if expireOn is undefined then days from now will be used
 */
export function setCookie (name: string, value: string, maxAge: string, days: number = 1) {
  let expires = ''
  if (maxAge) {
    expires = '; max-age=' + maxAge
  } else if (days) {
    const date = new Date()
    date.setHours(23, 59, 59, 0)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function getCookie (name: string) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return undefined
}

export function eraseCookie (name: string) {
  document.cookie = name + '=; Max-Age=-99999999;'
}
